<template>
  <div>
    <Head title="Nueva Unidad de Transporte" />

    <div class="max-w-2xl mx-auto">
      <div class="flex items-center gap-3 mb-6">
        <Link href="/transport-units" class="w-10 h-10 bg-white border border-gray-200 rounded-lg flex items-center justify-center text-gray-500 hover:bg-gray-50 transition-colors shadow-sm">
          <i class="fa fa-arrow-left" />
        </Link>
        <div>
          <h1 class="text-3xl font-bold text-gray-800">Nueva Unidad (Vehículo)</h1>
          <p class="text-gray-500 text-sm">Registra un vehículo y asígnalo a un transportista.</p>
        </div>
      </div>

      <div class="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <form class="space-y-5" @submit.prevent="submit">
          <!-- Empresa Transportista -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Empresa Transportista <span class="text-red-500">*</span></label>
            <select 
              v-model="form.carrier_id" 
              required
              class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 focus:ring-orange-500 focus:border-orange-500 transition-colors"
            >
              <option value="" disabled>Selecciona una empresa...</option>
              <option v-for="carrier in carriers" :key="carrier.id" :value="carrier.id">
                {{ carrier.name }}
              </option>
            </select>
            <p v-if="form.errors.carrier_id" class="text-red-500 text-xs mt-1">{{ form.errors.carrier_id }}</p>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <!-- Patente / Placa -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Patente / Matrícula <span class="text-red-500">*</span></label>
              <input 
                v-model="form.license_plate" 
                type="text" 
                required
                class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 focus:ring-orange-500 focus:border-orange-500 transition-colors uppercase"
                placeholder="Ej: ABC-123"
              />
              <p v-if="form.errors.license_plate" class="text-red-500 text-xs mt-1">{{ form.errors.license_plate }}</p>
            </div>
            
            <!-- Tipo de Vehículo -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Tipo de Vehículo <span class="text-red-500">*</span></label>
              <select 
                v-model="form.type" 
                required
                class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 focus:ring-orange-500 focus:border-orange-500 transition-colors"
              >
                <option value="" disabled>Selecciona un tipo...</option>
                <option value="Pequeño (Automóviles, furgón, pickup)">Pequeño (Automóviles, furgón, pickup)</option>
                <option value="Mediano (Camión Furgón, Plataforma, Jaula)">Mediano (Camión Furgón, Plataforma, Jaula)</option>
                <option value="Gandola (Furgón, Plataforma, Jaula, Doble)">Gandola (Furgón, Plataforma, Jaula, Doble)</option>
              </select>
            </div>
          </div>

          <!-- Chofer -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Nombre del Chofer / Conductor</label>
            <input 
              v-model="form.driver_name" 
              type="text" 
              class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 focus:ring-orange-500 focus:border-orange-500 transition-colors"
              placeholder="Ej: Juan Pérez"
            />
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <!-- Capacidad Kg -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Capacidad Máxima (Kg)</label>
              <input 
                v-model="form.capacity_kg" 
                type="number" 
                step="0.01"
                class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 focus:ring-orange-500 focus:border-orange-500 transition-colors"
                placeholder="Ej: 1500"
              />
            </div>
            
            <!-- Capacidad Volumen -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Capacidad Volumen (m³)</label>
              <input 
                v-model="form.capacity_volume" 
                type="number" 
                step="0.01"
                class="w-full bg-white border border-gray-200 rounded-lg px-4 py-2.5 focus:ring-orange-500 focus:border-orange-500 transition-colors"
                placeholder="Ej: 12.5"
              />
            </div>
          </div>

          <div class="pt-4 border-t border-gray-100 flex justify-end gap-3">
            <Link href="/transport-units" class="px-6 py-2.5 border border-gray-200 text-gray-700 rounded-lg hover:bg-gray-50 font-medium transition-colors">
              Cancelar
            </Link>
            <button 
              type="submit" 
              :disabled="form.processing"
              class="px-6 py-2.5 bg-orange-500 hover:bg-orange-600 disabled:opacity-50 text-white rounded-lg font-bold shadow-sm transition-colors"
            >
              Guardar Unidad
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: { Head, Link },
  layout: Layout,
  props: {
    carriers: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        carrier_id: '',
        license_plate: '',
        type: '',
        driver_name: '',
        capacity_kg: null,
        capacity_volume: null,
      }),
    }
  },
  methods: {
    submit() {
      this.form.post('/transport-units')
    },
  },
}
</script>
